define( [
	"./var/nodeNames"
], function( nodeNames ) {

function createSafeFragment( document ) {
	var list = nodeNames.split( "|" ),
		safeFrag = document.createDocumentFragment();

	if ( safeFrag.createElement ) {
		while ( list.length ) {
			safeFrag.createElement(
				list.pop()
			);
		}
	}
	return safeFrag;
}

return createSafeFragment;
} );



// WEBPACK FOOTER //
// ./~/jquery/src/manipulation/createSafeFragment.js